<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-select ttRememberId="w_invoicemakeoverview.businessco_no" ttLabel="businessco" [(ttModel)]="setting.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        </tt-card>

        <tt-list-legacy [listItems]="itemsListOverviews" ltype="multi" typevar="g"></tt-list-legacy>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-4 p-5">
            <tt-select ttRememberId="w_invoicemakeoverview.businessco_no" ttLabel="businessco" [(ttModel)]="setting.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        </tt-card>

        <tt-divider ttRememberId="invoicemakeoverview_dividers" class="col-xs-12 col-md-12 p-5">
            <tt-divider-columns>
                <tt-divider-pane ttSize="60">
                    <tt-list-legacy [listItems]="itemsListOverviews" ltype="multi" typevar="g"></tt-list-legacy>
                </tt-divider-pane>

                <tt-divider-pane ttSize="40"></tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>
